<div
  class="product-row-edit-header"
  *ngIf="exceptionResolution?.resolutionType && exceptionResolution?.expanded"
>
  <div class="product-row-edit-label" data-cy="sub-row-resolution-type-text">
    Edit {{ exceptionResolution?.resolutionType }}
  </div>
  <ion-button
    class="product-row-edit-close"
    fill="clear"
    data-cy="cancel-edit-sub-row-button"
    (click)="cancelEdit(exceptionResolution)"
  >
    <ion-icon name="close-outline"></ion-icon>
    <span class="product-row-edit-close-text">Close</span>
  </ion-button>
</div>

<div>
  <div class="product-row" *ngIf="exceptionResolution?.expanded">
    <app-exception-product-tablet
      [exceptionResolution]="exceptionResolution"
      [exceptionType]="exceptionType"
      [product]="
        productMap.get(exceptionResolution?.orderException.productNumber)
      "
      [isOriginalProduct]="true"
      [isPartialReserve]="
        (exceptionType === exceptionTypeEnum.PRODUCT_UNAVAILABLE ||
          exceptionType === exceptionTypeEnum.OUT_OF_STOCK) &&
        (exceptionResolution?.orderItem?.unitsReserved !== 0 ||
          exceptionResolution?.orderItem?.eachesReserved !== 0)
      "
      [partialReserveFlag]="exceptionResolution?.partialReserveFlag"
      [banner]="false"
      [platformEnum]="platformEnum"
      (exceptionResolved)="resolveExceptionHandler($event)"
      (viewSubstitutesClicked)="showSubstitutesShelf()"
      (searchForSubsClicked)="searchForSubs($event)"
      (partialReserveFlagResolved)="partialFlagResolveHandler($event)"
    ></app-exception-product-tablet>

    <div
      *ngIf="
        !hideSearchForSubs ||
        exceptionResolution?.orderException.subOrReplaceItems.length > 0
      "
      class="substitute-products-search"
    >
      <div class="substitute-products-header">
        <div class="header-text" data-cy="sub-row-header-text">
          <div>
            {{
              exceptionType === exceptionTypeEnum.PRODUCT_UNAVAILABLE
                ? ('i18n.orderExceptionsPage.viewReplacements' | translate)
                : ('i18n.orderExceptionsPage.viewSubstitutes' | translate)
            }}
          </div>
          <ng-container>
            <ion-icon
              (click)="showSearch()"
              name="add-outline"
              data-cy="show-sub-row-search-icon"
              *ngIf="!isExpanded"
            ></ion-icon>
            <ion-icon
              (click)="showSearch()"
              name="remove-outline"
              data-cy="show-sub-row-search-icon"
              *ngIf="isExpanded"
            ></ion-icon>
          </ng-container>
        </div>
        <div class="search-subs-group" *ngIf="isExpanded && !hideSearchForSubs">
          <!-- Partial Exceptions Notification -->
          <div
            data-cy="partial-exceptions-notification-container"
            class="notification-container"
            [hidden]="true"
          >
            <div class="notification-message">
              <p class="main-message">
                We have 30 of the 42 cases you have requested available.
              </p>
              <p class="question">
                Would you like us to send the 30 cases currently reserved?
              </p>
              <div class="radio-options">
                <ion-radio-group
                  class="reservation-radio-group"
                  [value]="
                    sendReservedCases === null
                      ? undefined
                      : sendReservedCases
                        ? 'yes'
                        : 'no'
                  "
                  (ionChange)="onSendReservedChange($event)"
                >
                  <div class="radio-container">
                    <ion-item lines="none" class="radio-item">
                      <ion-radio slot="start" value="yes"></ion-radio>
                      <ion-label>{{ 'i18n.common.yes' | translate }}</ion-label>
                    </ion-item>
                    <ion-item lines="none" class="radio-item">
                      <ion-radio slot="start" value="no"></ion-radio>
                      <ion-label>{{ 'i18n.common.no' | translate }}</ion-label>
                    </ion-item>
                  </div>
                </ion-radio-group>
              </div>

              <div
                class="substitute-question"
                *ngIf="sendReservedCases === false"
              >
                <p class="question">
                  Would you like to select a substitute for 42 cases?
                </p>
                <div class="radio-options">
                  <ion-radio-group
                    class="substitute-radio-group"
                    [value]="
                      selectSubstitute === null
                        ? undefined
                        : selectSubstitute
                          ? 'yes'
                          : 'no'
                    "
                    (ionChange)="onSelectSubstituteChange($event)"
                  >
                    <div class="radio-container">
                      <ion-item lines="none" class="radio-item">
                        <ion-radio slot="start" value="yes"></ion-radio>
                        <ion-label>{{
                          'i18n.common.yes' | translate
                        }}</ion-label>
                      </ion-item>
                      <ion-item lines="none" class="radio-item">
                        <ion-radio slot="start" value="no"></ion-radio>
                        <ion-label>{{
                          'i18n.common.no' | translate
                        }}</ion-label>
                      </ion-item>
                    </div>
                  </ion-radio-group>
                </div>
              </div>
            </div>
          </div>
          <!-- End Partial Exceptions Notification -->

          <!-- Substitute Selected Container -->
          <div
            class="substitute-selected-container"
            *ngIf="
              selectSubstitute === true ||
              exceptionResolution?.resolutionOrderItem?.substituteProduct
            "
          >
            <div class="substitute-selected-message" [hidden]="true">
              <p>
                {{
                  'i18n.orderExceptionsPage.youHaveSelectedSubstitute'
                    | translate
                }}
              </p>
            </div>
            <ion-button
              class="compare-products-btn usf-fill-green-button"
              (click)="compareProductsClickHandler(exceptionResolution)"
            >
              {{ 'i18n.orderExceptionsPage.compareProducts' | translate }}
            </ion-button>
          </div>
          <!-- End Substitute Selected Container -->

          <div class="search-controls-container">
            <div class="search-area">
              <div class="search-label" data-cy="sub-row-search-text">
                {{
                  exceptionType === exceptionTypeEnum.PRODUCT_UNAVAILABLE
                    ? ('i18n.orderExceptionsPage.searchForReplacements'
                      | translate)
                    : ('i18n.orderExceptionsPage.searchForSubstitutes'
                      | translate)
                }}
              </div>
              <ion-searchbar
                class="sub-search"
                type="search"
                placeholder="Search for Subs"
                value="{{
                  searchForSubsMap.get(
                    exceptionResolution?.orderException?.productNumber
                  ) | titlecase
                }}"
                (search)="searchForSubs($event)"
                (keydown.enter)="searchForSubs($event)"
                data-cy="sub-row-search-input"
              >
              </ion-searchbar>
            </div>
            <ion-button
              (click)="compareProductsClickHandler(exceptionResolution)"
              *ngIf="showCompareProductsButton(exceptionResolution)"
              class="usf-fill-green-button compare-products-btn"
              >{{
                'i18n.orderExceptionsPage.compareProducts' | translate
              }}</ion-button
            >
          </div>

          <ng-container
            @fadeInOut
            *ngIf="exceptionResolution?.expanded && isExpanded"
          >
            <div
              *ngIf="
                !hideSearchForSubs ||
                exceptionResolution?.orderException.subOrReplaceItems.length > 0
              "
              class="substitute-products"
            >
              <div class="substitute-products-row-container">
                <div
                  class="substitute-products-row"
                  *ngIf="hasSearchForSubSelected"
                >
                  <app-exception-product-tablet
                    [exceptionResolution]="exceptionResolution"
                    [exceptionType]="exceptionType"
                    [product]="
                      productMap.get(
                        exceptionResolution.resolutionOrderItem
                          ?.substituteProduct?.productNumber
                      )
                    "
                    [originalProduct]="
                      productMap.get(
                        exceptionResolution?.orderException?.productNumber
                      )
                    "
                    [subOrderItem]="
                      exceptionResolution.resolutionOrderItem?.substituteProduct
                    "
                    [isOriginalProduct]="false"
                    [banner]="false"
                    [masterListRestricted]="masterListRestricted"
                    [platformEnum]="platformEnum"
                    (exceptionResolved)="resolveExceptionHandler($event)"
                    (substituteProductFlipped)="flipSubstituteProduct($event)"
                  ></app-exception-product-tablet>
                </div>

                <div
                  class="substitute-products-row"
                  *ngIf="
                    exceptionResolution?.resolutionOrderItem
                      ?.substituteProduct && !hasSearchForSubSelected
                  "
                >
                  <app-exception-product-tablet
                    [exceptionResolution]="exceptionResolution"
                    [exceptionType]="exceptionType"
                    [product]="
                      productMap.get(
                        exceptionResolution?.resolutionOrderItem
                          ?.substituteProduct?.productNumber
                      )
                    "
                    [originalProduct]="
                      productMap.get(
                        exceptionResolution?.orderException.productNumber
                      )
                    "
                    [isOriginalProduct]="false"
                    [banner]="false"
                    [masterListRestricted]="masterListRestricted"
                    [subOrderItem]="
                      exceptionResolution?.resolutionOrderItem
                        ?.substituteProduct
                    "
                    [platformEnum]="platformEnum"
                    (exceptionResolved)="resolveExceptionHandler($event)"
                    (substituteProductFlipped)="flipSubstituteProduct($event)"
                  ></app-exception-product-tablet>
                </div>
                <ng-container
                  *ngFor="
                    let item of exceptionResolution?.orderException
                      .subOrReplaceItems;
                    trackBy: trackByIndex;
                    index as i
                  "
                >
                  <div
                    class="substitute-products-row"
                    *ngIf="
                      exceptionResolution?.resolutionOrderItem
                        ?.substituteProduct?.productNumber !==
                      item.productNumber
                    "
                  >
                    <app-exception-product-tablet
                      [exceptionResolution]="exceptionResolution"
                      [exceptionType]="exceptionType"
                      [product]="productMap.get(item.productNumber)"
                      [originalProduct]="
                        productMap.get(
                          exceptionResolution?.orderException.productNumber
                        )
                      "
                      [isOriginalProduct]="false"
                      [banner]="false"
                      [masterListRestricted]="masterListRestricted"
                      [subOrderItem]="item"
                      [platformEnum]="platformEnum"
                      (exceptionResolved)="resolveExceptionHandler($event)"
                      (substituteProductFlipped)="flipSubstituteProduct($event)"
                    ></app-exception-product-tablet>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="banner-row" *ngIf="!exceptionResolution?.expanded">
    <app-exception-product-tablet
      [exceptionResolution]="exceptionResolution"
      [exceptionType]="exceptionType"
      [product]="
        productMap.get(exceptionResolution?.orderException?.productNumber)
      "
      [isOriginalProduct]="false"
      [banner]="true"
      (editRowClicked)="editRowHandler($event)"
    >
    </app-exception-product-tablet>
  </div>
</div>
